import React from "react"

export default () => <div>Hello world!</div>


// WEBPACK FOOTER //
// ./src/pages/index.js